var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-sm-12" },
      [
        _c(
          "b-card",
          { staticClass: "mx-2" },
          [
            _c(
              "b-container",
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { md: "6" } }, [
                      _c("span", { staticClass: "mb-1" }, [
                        _vm._v(" Campaign Status Colors "),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#28a745",
                                color: "white",
                              },
                            },
                            [_vm._v("Completed")]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#4A7CBD",
                                color: "white",
                              },
                            },
                            [_vm._v("In Progress")]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#ffc107",
                                color: "black",
                              },
                            },
                            [_vm._v("Draft")]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#dc3545",
                                color: "white",
                              },
                            },
                            [_vm._v("Cancelled")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("b-col", { attrs: { md: "6" } }, [
                      _c("span", { staticClass: "mb-1" }, [
                        _vm._v(" Content Status Colors "),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#ffc107",
                                color: "black",
                              },
                            },
                            [_vm._v("Scheduled Content")]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#28a745",
                                color: "white",
                              },
                            },
                            [_vm._v("Published Content")]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#4A7CBD",
                                color: "white",
                              },
                            },
                            [_vm._v("Unpublished Content")]
                          ),
                          _c(
                            "b-badge",
                            {
                              staticClass: "mr-1",
                              staticStyle: {
                                "background-color": "#dc3545",
                                color: "white",
                              },
                            },
                            [_vm._v("Cancelled Content")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-sm-12" },
      [
        _c(
          "b-card",
          { staticClass: "mx-2" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Search Campaigns or Content:",
                  "label-for": "searchQuery",
                },
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "searchQuery",
                    placeholder: "Search campaigns or content...",
                  },
                  on: { input: _vm.filterCalendarEvents },
                  model: {
                    value: _vm.searchQuery,
                    callback: function ($$v) {
                      _vm.searchQuery = $$v
                    },
                    expression: "searchQuery",
                  },
                }),
              ],
              1
            ),
            _c("div", {
              ref: "ganttContainer",
              staticStyle: { width: "100%", height: "600px" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }